import { render, staticRenderFns } from "./tableBox.vue?vue&type=template&id=8c4abfda&scoped=true"
import script from "./tableBox.vue?vue&type=script&lang=js"
export * from "./tableBox.vue?vue&type=script&lang=js"
import style0 from "./tableBox.vue?vue&type=style&index=0&id=8c4abfda&lang=css"
import style1 from "./tableBox.vue?vue&type=style&index=1&id=8c4abfda&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4abfda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c4abfda')) {
      api.createRecord('8c4abfda', component.options)
    } else {
      api.reload('8c4abfda', component.options)
    }
    module.hot.accept("./tableBox.vue?vue&type=template&id=8c4abfda&scoped=true", function () {
      api.rerender('8c4abfda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/archives/components/tableBox.vue"
export default component.exports